"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPrimitiveAttrDTO = void 0;
const isEmpty_js_1 = require("../../../../utils/isEmpty.js");
const isBigInt_js_1 = require("../../../../utils/validation/isBigInt.js");
const isObject_js_1 = require("../../../../utils/validation/isObject.js");
const utils_js_1 = require("./utils.js");
const isTransformerWithDTO = (transformer) => (0, isObject_js_1.isObject)(transformer) && 'transformerId' in transformer && 'toJSON' in transformer;
/**
 * @debt feature "handle defaults, links & validators DTOs"
 */
const getPrimitiveAttrDTO = (attr) => {
    const defaultsDTO = (0, utils_js_1.getDefaultsDTO)(attr);
    const attrDTO = {
        type: attr.type,
        ...(attr.required !== 'atLeastOnce' ? { required: attr.required } : {}),
        ...(attr.hidden !== false ? { hidden: attr.hidden } : {}),
        ...(attr.key !== false ? { key: attr.key } : {}),
        ...(attr.savedAs !== undefined ? { savedAs: attr.savedAs } : {}),
        ...(attr.transform !== undefined
            ? {
                transform: isTransformerWithDTO(attr.transform)
                    ? attr.transform.toJSON()
                    : { transformerId: 'custom' }
            }
            : {}),
        ...(!(0, isEmpty_js_1.isEmpty)(defaultsDTO) ? { defaults: defaultsDTO } : {})
        // We need to cast as `.enum` is not coupled to `.type`
    };
    if (attr.enum) {
        switch (attr.type) {
            case 'binary': {
                const textDecoder = new TextDecoder('utf8');
                // @ts-ignore type inference can be improved here (NullAttrDTO has no 'enum' prop)
                attrDTO.enum = attr.enum.map(value => btoa(textDecoder.decode(value)));
                break;
            }
            case 'number': {
                // @ts-ignore type inference can be improved here (NullAttrDTO has no 'enum' prop)
                attrDTO.enum = attr.enum.map(value => ((0, isBigInt_js_1.isBigInt)(value) ? value.toString() : value));
                break;
            }
            default:
                // @ts-ignore type inference can be improved here (NullAttrDTO has no 'enum' prop)
                attrDTO.enum = attr.enum;
        }
    }
    return attrDTO;
};
exports.getPrimitiveAttrDTO = getPrimitiveAttrDTO;
